type BuildWalletByPairParamsArgs = {
  counterpartId: string
  isAdvertiserAccount: boolean
}

export const buildWalletByPairParams = ({
  counterpartId,
  isAdvertiserAccount
}: BuildWalletByPairParamsArgs): ListCheckingAccountRequestParams => ({
  account_info: true,
  page: 1,
  quantity: 1,
  overview: true,
  count: 'false',
  ...(isAdvertiserAccount
    ? { publisher_id: counterpartId }
    : { advertiser_id: counterpartId })
})
